{
  "title": "Orders",
  "subtitle": "Every order from every channel, from the draft to the customer.",
  "draftTitle": "Draft",
  "status": {
    "draft": "Draft",
    "placed": "Placed",
    "confirmed": "Confirmed",
    "completed": "Completed",
    "cancelled": "Cancelled"
  },
  "fulfillment": {
    "unfulfilled": "Not prepared",
    "inProgress": "Being prepared",
    "fulfilled": "Handed over",
    "partlyReturned": "Partly returned",
    "returned": "Returned"
  },
  "payment": {
    "unpaid": "Unpaid",
    "partlyPaid": "Partly paid",
    "paid": "Paid",
    "partlyRefunded": "Partly refunded",
    "refunded": "Refunded"
  },
  "steps": {
    "picking": "Picking",
    "packed": "Packed",
    "shipped": "Shipped",
    "delivered": "Delivered",
    "readyForPickup": "Ready for pickup",
    "collected": "Collected",
    "handedOver": "Handed over"
  },
  "modes": {
    "shipping": "Shipping",
    "pickup": "Pickup",
    "counter": "At the counter"
  },
  "tabs": {
    "open": "Open",
    "toPrepare": "To prepare",
    "onTheWay": "On the way",
    "drafts": "Drafts",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "all": "All"
  },
  "list": {
    "new": "New order",
    "noCustomer": "No customer",
    "search": "Order number or customer",
    "site": "Site",
    "allSites": "All sites",
    "channel": "Channel",
    "allChannels": "All channels",
    "carrier": "Carrier",
    "allCarriers": "All carriers",
    "payment": "Payment",
    "allPayments": "All payments",
    "due": "Still to pay",
    "queueHint": "Confirmed orders waiting to be prepared and handed over, oldest first.",
    "showing_one": "{{first}}–{{last}} of {{total}} order",
    "showing_other": "{{first}}–{{last}} of {{total}} orders",
    "pricingMode": "Prices",
    "allPricingModes": "Retail and wholesale"
  },
  "empty": {
    "title": "No order yet",
    "text": "Take an order for a customer by phone or at the back office; online orders will arrive here too."
  },
  "noMatch": {
    "open": "No open order",
    "toPrepare": "Nothing to prepare",
    "onTheWay": "Nothing on the way",
    "drafts": "No draft",
    "completed": "No completed order",
    "cancelled": "No cancelled order",
    "all": "No order found"
  },
  "columns": {
    "order": "Order",
    "customer": "Customer",
    "site": "Site",
    "status": "Status",
    "payment": "Payment",
    "total": "Total (TND)",
    "date": "Date",
    "product": "Product",
    "quantity": "Quantity",
    "unitPrice": "Unit price",
    "discount": "Discount",
    "lineTotal": "Total"
  },
  "editor": {
    "newTitle": "New order",
    "editTitle": "Edit the draft",
    "changeTitle": "Change order {{number}}",
    "changeHint": "Lines left as they are keep their price; new and changed lines take today's. Nothing changes until you save.",
    "saveChanges": "Save the changes",
    "changed": "Order {{number}} changed",
    "hint": "Saved as you type. Prices come from the channel’s price list, tax included.",
    "saving": "Saving…",
    "unsaved": "Changes not saved yet",
    "saved": "Draft saved",
    "notSaved": "Not saved yet",
    "whoWhere": "Customer and delivery",
    "channel": "Channel",
    "site": "Site",
    "siteHint": "Where the stock leaves from.",
    "siteFixed": "The channel’s site.",
    "pickSite": "Choose a site",
    "customer": "Customer",
    "customerSearch": "Phone, name or customer number",
    "noCustomer": "No customer found.",
    "newCustomer": "New customer",
    "changeCustomer": "Change",
    "delivery": "Delivery",
    "address": "Delivery address",
    "pickAddress": "Choose an address",
    "otherAddress": "Another address…",
    "addressFields": {
      "line1": "Address",
      "line2": "Address line 2",
      "city": "City",
      "postalCode": "Postal code",
      "governorate": "Governorate",
      "recipient": "Recipient",
      "phone": "Phone at the address"
    },
    "shippingFee": "Shipping fee",
    "carrier": "Carrier",
    "channelCarrier": "The channel's: {{name}}",
    "carrierLater": "Chosen at shipping",
    "pickupSite": "Pickup site",
    "payment": "Payment method",
    "paymentLater": "Decided later",
    "promoCode": "Promotion code",
    "promoCodeHint": "A promotion that asks for it then applies.",
    "notes": "Notes for the team",
    "lines_one": "{{count}} line",
    "lines_other": "{{count}} lines",
    "scanPlaceholder": "Scan, or type a SKU or a name, then Enter",
    "noLines": "No product yet: scan a barcode or search a product.",
    "available": "{{quantity}} {{unit}} available",
    "removeLine": "Remove {{name}}",
    "quantity": "Quantity",
    "unitPrice": "Unit price",
    "discount": "Discount",
    "lineTotal": "Total",
    "placeConfirm": "Place and reserve the stock",
    "placeOnly": "Place without reserving",
    "placeHint": "Placing gives the order its number and freezes its prices; reserving keeps its stock.",
    "placed": "Order {{number}} placed",
    "placedConfirmed": "Order {{number}} placed, its stock is reserved",
    "pricingMode": "Prices",
    "wholesaleHint": "Each product at its wholesale price; a product without one cannot be ordered.",
    "promotion": "{{name}}: −{{amount}}"
  },
  "totals": {
    "title": "Totals",
    "lines": "Lines",
    "discounts": "Discounts",
    "shipping": "Shipping",
    "total": "Total",
    "tax": "Including VAT {{rate}}%",
    "taxOn": "VAT {{rate}}% on {{net}}",
    "empty": "Totals show once the first line is saved."
  },
  "page": {
    "steps": "Steps of the order",
    "skipped": "Skipped",
    "lines_one": "{{count}} line",
    "lines_other": "{{count}} lines",
    "vat": "VAT {{rate}}%",
    "returned": "{{quantity}} {{unit}} returned",
    "timeline": "Timeline",
    "timelineHint": "Every step, with who and when.",
    "confirmed": "Order {{number}} confirmed, its stock is reserved",
    "edit": "Edit",
    "place": "Place order",
    "confirm": "Reserve the stock",
    "return": "Take back items",
    "deliveryNote": "Delivery note",
    "cancel": "Cancel order",
    "cancelPicking": "Cancel picking",
    "cancelPickingTitle": "Cancel the picking of {{number}}?",
    "cancelPickingText": "The order goes back to the start of its preparation and can be changed again. Its stock stays reserved: put back what was already picked.",
    "pickingCancelled": "Picking cancelled: the order can be changed",
    "cancelledTitle": "Cancelled",
    "placedTitle": "Placed, stock not reserved yet",
    "placedText": "Reserve the stock to confirm the order: the site then prepares it.",
    "expiresTitle": "Waiting for the online payment",
    "expiresText": "Without payment by {{date}}, the order is cancelled and its stock is free again.",
    "shortTitle": "Not enough stock at this site",
    "shortLine": "{{name}}: {{available}} {{unit}} available",
    "returns": "Returns",
    "lateReturn": "After the return period",
    "customer": "Customer",
    "name": "Name",
    "phone": "Phone",
    "email": "Email",
    "delivery": "Delivery",
    "mode": "Mode",
    "address": "Address",
    "pickupSite": "Pickup site",
    "trackParcel": "Track the parcel on the carrier's site",
    "returnUntil": "Returns accepted until",
    "details": "Details",
    "payment": "Payment method",
    "promoCode": "Promotion code",
    "priceList": "Price list",
    "created": "Started",
    "placedAt": "Placed",
    "confirmedAt": "Confirmed",
    "completedAt": "Completed",
    "tillCancelTitle": "Cancelled at the till on {{date}} by {{by}}",
    "approvedBy": "allowed by {{name}}",
    "noReceiptTitle": "Taken back at the till without a receipt",
    "noReceiptText": "Items brought back at today's price and paid back in cash; this order holds that return only.",
    "campaign": "Campaign",
    "landing": "First page seen",
    "googleClick": "Google ad",
    "metaClick": "Meta ad"
  },
  "cancel": {
    "title": "Cancel {{number}}?",
    "releases": "Its reserved stock is free again at once.",
    "confirm": "Cancel order",
    "reason": "Why",
    "note": "Note",
    "done": "{{number}} cancelled",
    "reasons": {
      "customerRequest": "The customer asked",
      "outOfStock": "Out of stock",
      "paymentFailed": "Payment failed",
      "duplicate": "Entered twice",
      "reservationExpired": "Not paid in time",
      "other": "Other reason"
    }
  },
  "step": {
    "done": "Step done: {{step}}",
    "carrier": "Carrier",
    "tracking": "Tracking number",
    "pickCarrier": "Choose the carrier",
    "noCarriers": "No carrier yet.",
    "addCarriers": "Add carriers",
    "handOverHint": "The stock leaves now: from the site’s fullest places, at the average cost.",
    "titles": {
      "picking": "Start picking {{number}}?",
      "packed": "{{number}} is packed?",
      "shipped": "Ship {{number}}",
      "delivered": "{{number}} was delivered?",
      "readyForPickup": "{{number}} is ready for pickup?",
      "collected": "Hand {{number}} to the customer?",
      "handedOver": "Hand {{number}} over?"
    },
    "actions": {
      "picking": "Start picking",
      "packed": "Mark as packed",
      "shipped": "Ship",
      "delivered": "Mark as delivered",
      "readyForPickup": "Ready for pickup",
      "collected": "Collected",
      "handedOver": "Hand over"
    },
    "texts": {
      "picking": "The team starts gathering the items; the alert of the site closes.",
      "packed": "The parcel is ready to leave.",
      "shipped": "The parcel leaves with the carrier.",
      "delivered": "The customer received the parcel: the order is completed.",
      "readyForPickup": "The order waits at the pickup site.",
      "collected": "The customer took the order: its stock leaves and the order is completed.",
      "handedOver": "The customer takes the order now: its stock leaves and the order is completed."
    }
  },
  "return": {
    "title": "Take back items of {{number}}",
    "hint": "The stock comes back at the cost it left with. Refunds come with payments.",
    "confirm": "Take back",
    "done": "Return recorded",
    "lateTitle": "The return period is over",
    "lateText": "It ended on {{date}}: only people allowed to accept late returns can do this.",
    "left": "{{quantity}} {{unit}} can come back",
    "quantityOf": "Quantity of {{name}} coming back",
    "reason": "Why",
    "place": "Back to",
    "placeHint": "A shelf, or a place for damaged goods.",
    "note": "Note",
    "reasons": {
      "changedMind": "Changed their mind",
      "defective": "Defective",
      "wrongItem": "Wrong item",
      "damaged": "Damaged",
      "other": "Other reason"
    }
  },
  "note": {
    "title": "Delivery note",
    "print": "Print",
    "to": "Deliver to",
    "how": "Delivery",
    "preparedBy": "Stamp and signature of the sender",
    "receivedBy": "Received in good condition by",
    "mode": "Mode",
    "pickup": "Pickup point",
    "carrier": "Carrier",
    "tracking": "Tracking no.",
    "remarks": "Remarks",
    "dateTitle": "Date of the delivery note"
  },
  "pricingModes": {
    "retail": "Retail (the channel's list)",
    "wholesale": "Wholesale"
  }
}
